import { initContract } from '@ts-rest/core';
import { PlanCatalogue } from './plan-catalogue';

const c = initContract();

export namespace OnboardApi {
    export type Invoice = {
        url: string;
        dueDate: { year: number; month: number; day: number };
    };

    export type Plan = { type: PlanCatalogue.PlanId };

    export type Payment = {
        state:
            | { type: 'invoice_not_generated'; requiresCpf: boolean; isFreeTrialEligible: boolean }
            | { type: 'waiting_for_payment'; isTrial: boolean; invoice: Invoice }
            | { type: 'paid' }
            | { type: 'active' };
    };

    export type BusinessInfo = {
        name: string;
        slug: string;
        requiresCpf: boolean;
    };

    export type GenerateInvoiceRequest = {
        customerCpfOrCnpj: string | null;
        plan: Plan;
        isEligibleForTrial: boolean;
    };

    export type GenerateInvoiceResponse = {
        invoice: Invoice | null;
        isTrial: boolean;
    };

    export const contract = c.router(
        {
            getBusinessInfo: c.query({
                method: 'GET',
                path: '/business',
                responses: {
                    200: c.type<BusinessInfo | null>(),
                },
            }),
            setBusinessInfo: c.mutation({
                method: 'PUT',
                path: '/business',
                body: c.type<{ name: string; slug: string }>(),
                responses: {
                    204: c.noBody(),
                },
            }),
            getPayment: c.query({
                method: 'GET',
                path: '/payment',
                responses: {
                    200: c.type<Payment>(),
                },
            }),
            generateInvoice: c.mutation({
                method: 'POST',
                path: '/invoices',
                body: c.type<GenerateInvoiceRequest>(),
                responses: {
                    200: c.type<GenerateInvoiceResponse>(),
                },
            }),
        },
        { strictStatusCodes: true },
    );
}
